export default function Logo() {
  return (
    <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4 bg-blue-600 rounded-2xl">
      <i className="ri-water-flash-line text-2xl text-white"></i>
    </div>
  );
}
